import React, { FC, useContext, useEffect, useState } from "react";
import cn from "clsx";
import map from "lodash/map";
import { useTranslation } from "react-i18next";
import Scrollbars from "react-custom-scrollbars";
import { useAppSelector } from "@/redux/store";
import useBodyScrollability from "@/hooks/useBodyScrollability";
import { getQuantityList } from "@/util/add-to-cart";
import { selectProductIsSingleSize } from "@/routes/pdp/selectors";
import SlideBottomToTop from "../../slide-bottom-to-top";
import { productErrorContext } from "../webSizes/productWebSizes";
import { ProductQuantityProps } from "./types";
import "./style.scss";

const ProductQuantityMob: FC<ProductQuantityProps> = ({
  selectedSize,
  selectedQty,
  setSelectedQty
}) => {
  const { selectSizeFirstError, setSelectSizeFirstError } =
    useContext(productErrorContext);
  const [openQuantity, setOpenQuantity] = useState(false);
  const productIsSingleSize = useAppSelector(selectProductIsSingleSize);
  const { disableBodyScroll, enableBodyScroll } = useBodyScrollability();
  const { t } = useTranslation("productDetails");
  let timeout = null;

  const allowedQuantity = selectedSize?.sizeStock;
  const quantityList = getQuantityList(allowedQuantity);
  const selectedItemQuantity = quantityList.length ? selectedQty : 1;

  const handleQtyModal = (allowedQuantity?: number) => {
    if (allowedQuantity || productIsSingleSize) {
      disableBodyScroll();
      setOpenQuantity(!openQuantity);
      setSelectSizeFirstError(false);
    } else if (!selectedSize.size) {
      setSelectSizeFirstError(true);
      timeout = setTimeout(() => setSelectSizeFirstError(false), 3000);
    }
  };

  const onQuantityClick = (quantity: number) => {
    setSelectedQty(quantity);
    handleCloseModal();
  };

  const handleCloseModal = (): void => {
    enableBodyScroll();
    setOpenQuantity(false);
  };

  useEffect(() => {
    return () => {
      timeout && clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      {selectSizeFirstError && (
        <p className="qty_size_select">{t("selectSizeFirst")}</p>
      )}
      <div className="quantitySelectMobile">
        <div
          className="qtyInput"
          onClick={() => handleQtyModal(allowedQuantity)}
        >
          <span className="qty_text">{t("qty")}</span>
          {selectedItemQuantity}
        </div>
      </div>
      <div
        className={cn(
          "slideTop quantityContainer",
          openQuantity ? "slideUp" : "slideBack"
        )}
      >
        <div className="backOverlay" onClick={handleCloseModal} />
        <Scrollbars autoHeight autoHeightMin={100} autoHeightMax={285}>
          <SlideBottomToTop>
            <ul className="dropdown_content_container">
              <li>{t("selectQuantity")}</li>
              {map(quantityList, quantity => (
                <li key={quantity} onClick={() => onQuantityClick(quantity)}>
                  {quantity}
                </li>
              ))}
            </ul>
          </SlideBottomToTop>
        </Scrollbars>
      </div>
    </>
  );
};

export default ProductQuantityMob;
